var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MatDialog } from '@angular/material';
import { PpApiGatewayService } from '@app/pp-api-gateway.service';
import { FINANCED_CHARGE_TYPES } from '@app/types/rate-plan';
import { SessionStorage } from '@app/types/session-storage.enum';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AUTO_RENEW_UPDATE_COUNTRIES, CANCELLATION_IN_PROGRESS_KEY, DIALOG_CONFIG, FLOWS_DIALOGS, FLOWS_TRANSLATIONS, Flows } from './auto-renew.type';
import { UserService } from '@app/user.service';
var AutoRenewService = /** @class */ (function () {
    function AutoRenewService(dialog, ppApiGatewayService, userService) {
        this.dialog = dialog;
        this.ppApiGatewayService = ppApiGatewayService;
        this.userService = userService;
        this.autoRenewUpdated$ = new BehaviorSubject(null);
    }
    Object.defineProperty(AutoRenewService.prototype, "isAutoRenewDisabled", {
        get: function () {
            return this.ratePlan.autoRenew && !this.ratePlan.renewalDate;
        },
        enumerable: true,
        configurable: true
    });
    AutoRenewService.prototype.initialize = function (ratePlan, accountId) {
        this.ratePlan = ratePlan;
        this.accountId = accountId;
        this.isFinanced = FINANCED_CHARGE_TYPES.includes(this.ratePlan.charge);
    };
    AutoRenewService.prototype.trigger = function (autoRenew, onSuccess, onError) {
        var countryISO = sessionStorage.getItem(SessionStorage.Country);
        var isCustomCountry = AUTO_RENEW_UPDATE_COUNTRIES.includes(countryISO);
        var servicePhoneNumber = decodeURI(sessionStorage.getItem(SessionStorage.ServicePhoneNumber));
        var studentPhoneNumber = sessionStorage.getItem(SessionStorage.StudentPhoneNumber);
        var data = {
            servicePhoneNumber: servicePhoneNumber,
            studentPhoneNumber: studentPhoneNumber,
            confirm$: this.requestCancellationCall$()
        };
        var selectedFlow = Flows.CANCELLATION_REQUEST;
        if (isCustomCountry && !this.isFinanced) {
            selectedFlow = Flows.AUTO_RENEW_UPDATE;
            data = {
                confirm$: this.updateAutoRenewal$(autoRenew, this.accountId),
                autoRenew: autoRenew,
            };
        }
        if (this.getCancellationInProgress()) {
            selectedFlow = Flows.CANCELLATION_IN_PROGRESS;
            data = {
                servicePhoneNumber: servicePhoneNumber,
            };
        }
        var callbacks = {
            onSuccess: function (value) { return onSuccess(selectedFlow, value); },
            onError: function (value) { return onError(selectedFlow, value); },
        };
        this.openDialog(selectedFlow, __assign({}, data, callbacks));
    };
    AutoRenewService.prototype.openDialog = function (flow, data) {
        this.dialog.open(FLOWS_DIALOGS[flow], this.getDialogConfig(flow, data));
    };
    AutoRenewService.prototype.getDialogConfig = function (flow, data) {
        return (__assign({ data: __assign({}, FLOWS_TRANSLATIONS[flow], data) }, DIALOG_CONFIG));
    };
    AutoRenewService.prototype.setCancellationInProgress = function () {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 3);
        window.localStorage.setItem(CANCELLATION_IN_PROGRESS_KEY, expirationDate.toUTCString());
    };
    AutoRenewService.prototype.getCancellationInProgress = function () {
        var expirationDateEntry = window.localStorage.getItem(CANCELLATION_IN_PROGRESS_KEY);
        if (!expirationDateEntry) {
            return false;
        }
        var expirationDate = new Date(expirationDateEntry);
        return expirationDate.getTime() > Date.now();
    };
    AutoRenewService.prototype.requestCancellationCall$ = function () {
        var _this = this;
        return this.ppApiGatewayService.requestCancellationCall(this.userService.contactId).pipe(tap(function () { return _this.setCancellationInProgress(); }));
    };
    AutoRenewService.prototype.updateAutoRenewal$ = function (autoRenew, accountId) {
        var _this = this;
        return this.ppApiGatewayService.updateAutoRenewal(autoRenew, accountId).pipe(tap(function () { return _this.autoRenewUpdated$.next(null); }));
    };
    return AutoRenewService;
}());
export { AutoRenewService };
